export default __webpack_public_path__ + "static/hex-background-bc7c6081c23e5273fb5dd7df593f13df.svg";